import { render, staticRenderFns } from "./FactoryManagement.vue?vue&type=template&id=afbc754e"
import script from "./FactoryManagement.vue?vue&type=script&lang=js"
export * from "./FactoryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports